import { FC } from "react";
import { useGetGFAFullDetails } from "../../../api/queries/gfa.queries";
import { useParams } from "react-router-dom";
import { Loader } from "@dune/ui";
import { TabLayoutErrorSkeleton } from "../../../component/layout/PageLayoutWithTabs";
import { CommonProjectForm } from "./CommonProjectForm";

export const EditGFAProjectForm: FC = () => {
	const { id: projectId } = useParams<{ id: string }>();
	if (!projectId) {
		throw new Error("Project ID is required");
	}

	const { data: gfa, isLoading } = useGetGFAFullDetails(projectId);

	if (isLoading) {
		return <Loader />;
	}

	if (!isLoading && !gfa) {
		return (
			<TabLayoutErrorSkeleton message="Erreur lors du chargement des informations du projet." />
		);
	}

	return (
		<CommonProjectForm
			projectId={projectId}
			projectType="gfa"
			GFAFullDetails={gfa}
		/>
	);
};
